import React from 'react'
import ProductAdminLayout from '../../../../../components/layouts/ProductAdminLayout'
import FaqMgnt from '../../../../../components/admin/product/faq/FaqMgnt'

const AdminFAQ = props => (
  <FaqMgnt />
)

AdminFAQ.Layout = ProductAdminLayout

export default AdminFAQ
